import React, { useState, useCallback } from 'react';
import { Menu, X } from 'lucide-react';
import logoSeal from '../assets/logo-seal.png';

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleNavClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) {
      const targetPos = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: targetPos, behavior: 'smooth' });
    }
  }, []);

  return (
    <nav className="site-nav" aria-label="Primary">
      <div className="nav-inner">
        <a href="#home" className="nav-logo" onClick={(e) => handleNavClick(e, '#home')}>
          <img src={logoSeal} alt="" className="nav-shield" aria-hidden="true" />
          <span className="nav-wordmark">Garden Spot</span>
        </a>
        <ul className={`nav-links${menuOpen ? ' open' : ''}`} id="primary-menu">
          <li><a href="#approach" onClick={(e) => handleNavClick(e, '#approach')}>Approach</a></li>
          <li><a href="#projects" onClick={(e) => handleNavClick(e, '#projects')}>Projects</a></li>
          <li><a href="#community" onClick={(e) => handleNavClick(e, '#community')}>Community</a></li>
          <li><a href="#contact" className="nav-cta" onClick={(e) => handleNavClick(e, '#contact')}>Get in Touch</a></li>
        </ul>
        <button
          className="nav-toggle"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="primary-menu"
        >
          {menuOpen ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>
    </nav>
  );
}
